var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }
import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import countBy from 'lodash/countBy';
import orderBy from 'lodash/orderBy';
import { DEVICE_STATUS } from 'roomba/components/status-badge/component';
import { getDeviceStatus } from 'roomba/utils/deviceStatus';
const ROOMS_PER_PAGE = 25;
let RoombaListController = (_class = class RoombaListController extends Controller {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "roomsPolling", _descriptor, this);
    _initializerDefineProperty(this, "featureFlags", _descriptor2, this);
    _initializerDefineProperty(this, "roomsSearchInput", _descriptor3, this);
    _initializerDefineProperty(this, "pageNumber", _descriptor4, this);
    _initializerDefineProperty(this, "pageSize", _descriptor5, this);
    _initializerDefineProperty(this, "sortField", _descriptor6, this);
    _initializerDefineProperty(this, "sortDirection", _descriptor7, this);
  }
  get DEVICE_STATUS() {
    return DEVICE_STATUS;
  }
  get roomsWithDeviceStatuses() {
    return orderBy(this.roomsPolling.roomsList.map(room => ({
      ...room,
      overallDevicesStatus: this.getOverallDevicesStatus(room)
    })).filter(room => room.name.toLowerCase().includes(this.roomsSearchInput.toLowerCase())), this.sortField, this.sortDirection);
  }
  get paginatedRoomsWithDeviceStatuses() {
    return this.roomsWithDeviceStatuses.slice(this.pageNumber * ROOMS_PER_PAGE - ROOMS_PER_PAGE, this.pageNumber * ROOMS_PER_PAGE);
  }
  mutateRoomsSearchInput(value) {
    this.roomsSearchInput = value;
    this.pageNumber = 1;
  }
  clearRoomsSearchInput() {
    this.roomsSearchInput = '';
  }
  getOverallDevicesStatus(room) {
    if (!room?.devices.length) {
      return;
    }
    return countBy(room.devices.map(device => ({
      status: getDeviceStatus(device)
    })), 'status');
  }
  sortAction(sortField, direction) {
    this.sortField = sortField;
    this.sortDirection = direction;
  }
  setPageNumber(pageNumber) {
    this.pageNumber = pageNumber;
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "roomsPolling", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "featureFlags", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "roomsSearchInput", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "pageNumber", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 1;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "pageSize", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return ROOMS_PER_PAGE;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "sortField", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 'name';
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "sortDirection", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 'asc';
  }
}), _applyDecoratedDescriptor(_class.prototype, "mutateRoomsSearchInput", [action], Object.getOwnPropertyDescriptor(_class.prototype, "mutateRoomsSearchInput"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clearRoomsSearchInput", [action], Object.getOwnPropertyDescriptor(_class.prototype, "clearRoomsSearchInput"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sortAction", [action], Object.getOwnPropertyDescriptor(_class.prototype, "sortAction"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setPageNumber", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setPageNumber"), _class.prototype)), _class);
export { RoombaListController as default };